module.exports = __webpack_public_path__ + "media/icons/naped-przod-blue@3x-5e3205a9.svg";